import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubSuggestedArticlesRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-suggested-topics',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
	exact: true,
};
